import React from 'react';
import img1 from './../components/assets/images/icons8-gmail-48.png';
import img2 from './../components/assets/images/icons8-zoom-48.png';
import img3 from './../components/assets/images/4821951.png';
import img4 from './../components/assets/images/logo3.png';
const Footer = () => (
  <footer>
    <div className="footer-container">
      <div className="footer-item">
        <img width={40} height={40} src={img1} alt="Email Icon" />
        <a href="mailto:ebrahimihello@gmail.com">ebrahimihello@gmail.com</a>
      </div>
      <div className="footer-item">
        <img width={40} height={40} src={img3} alt="Location Icon" />
        <a href="https://www.google.com/maps/search/?api=1&query=SUNY+Old+Westbury+223+Store+Hill+Rd+Old+Westbury,+NY+11568" target="_blank" rel="noopener noreferrer">
          Dr. Ebrahimi SUNY Old Westbury 223 Store Hill Rd Old Westbury, NY 11568 School of Business
        </a>
      </div>
      <div className="footer-item">
        <img width={40} height={40} src={img2} alt="Phone Icon" />
        <a href="tel:6157421282">6157421282</a>
      </div>
    </div>
    <p className="powered-by">Powered by <a href="https://www.finitsystems.com" target="_blank" rel="noopener noreferrer">Finit Systems Inc</a></p>
  </footer>
);

export default Footer;
